import TargetGroupModal from "./TargetGroupModal";

/** @namespace TargetGroupModal */
export default TargetGroupModal;
